import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";
import { getUserDetails } from "../utils/userDetailsUtils";

const restoreTestSuite = async ({ productId, testSuiteId }) => {
  const user = getUserDetails();

  const params = new URLSearchParams({
    action: "undoSuiteDel",
    companyid: user.companyid,
    productid: productId,
    testSuiteId: testSuiteId,
  });

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?${params.toString()}`,
  );

  return response.data;
};

const useRestoreTestSuiteMutation = (options = {}) => {
  return useMutation({
    mutationFn: restoreTestSuite,
    ...options,
  });
};

export default useRestoreTestSuiteMutation;
